import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function ClientBrief() {
  return (
    <section className="client__brief p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={10} className="m-auto text-center">
            <h2 style={{ color: "#000" }}>
              Client <span style={{ color: "#644BB1" }}>Brief</span>
            </h2>
            <p>
              qRoll is the mobile application for Talpool, a platform that helps
              people with talents and skills connect with recruiters, such as
              models and photographers, and find work.
            </p>
            <h2 style={{ color: "#000" }}>Mission</h2>
            <div className="mission_boxes">
              <div className="mission_box">
                YEAR - <span style={{ color: "#644BB1" }}> 2018</span>
              </div>
              <div className="mission_box">
                ROLE - <span style={{ color: "#644BB1" }}> UI/UX DESIGN</span>
              </div>
              <div className="mission_box">
                TYPE -
                <span style={{ color: "#644BB1" }}> MOBILE APPLICATION</span>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default ClientBrief;
